import Vue from 'vue';
export const EventManager = new Vue();


// WEBPACK FOOTER //
// ./scripts/vue/EventManager.js